import {FC, useEffect} from "react";
import {loadCaptchaScript} from "./load-captcha";

type CaptchaMode = "fails" | "challenge" | "server-fail";

type Props = {
  tokenCallback: (token: string) => void;
  visible?: boolean;
  mode?: CaptchaMode;
}

function getSiteKey(mode?: CaptchaMode) {
  if (mode === "fails") {
    return "2x00000000000000000000AB"
  }
  if (mode === "challenge") {
    return "3x00000000000000000000FF";
  }
  return "0x4AAAAAAABdCqTWJFCpKwWj";
}

export const Captcha: FC<Props> = ({tokenCallback, mode, visible = false}) => {
  useEffect(() => {
    loadCaptchaScript().then(turnstile => {
      if (!turnstile) {
        console.error("error loading turnstile");
        return;
      }
      const sitekey = getSiteKey(mode);

      turnstile.render("#captcha-container", {
        sitekey,
        theme: "light",
        callback: (token) => {
          if (mode === "server-fail") {
            tokenCallback("invalid-captcha-token");
          } else {
            tokenCallback(token);
          }
        },
      });
    })
  }, [])
  const className = visible ? "" : "invisible h-0";
  return <div id="captcha-container" data-testid="captcha-container" className={className}/>;
};



